<mat-card appearance="outlined" style="padding: 30px;">
    <mat-card-title>{{data.title}}</mat-card-title>
    <mat-card-content class="content">{{data.text}}</mat-card-content>
    <div mat-dialog-actions align="end">
        <button mat-button (click)="onDismiss()">Luk</button>&nbsp;
    </div>
</mat-card>